export default function SkeletonEventoBanner() {
  return (
   
      <div className="bg-white animate-pulse h-full w-full"></div>
     );
}
